export const CURRENCY_FORMAT = { max: 2 }
